import { useState, useEffect } from 'react'
import { authCheck } from '../service/api'

export default function useAdmin() {
  const [isAdmin, setIsAdmin] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  useEffect(() => {
    let current = true
    setIsLoading(true)
    authCheck()
      .then((response) => {
        if (response.status === 200) {
          current && setIsAdmin(true)
        }
        current && setIsLoading(false)
      })
      .catch(() => {
        current && setIsLoading(false)
      })
    return () => {
      current = false
    }
  }, [])
  return { isAdmin, isLoading }
}
